import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import VisibilityIcon from "@material-ui/icons/Visibility";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { bookingApi } from "functions/apis";
import PublicationStatus from "enums/PublicationStatus";
import { formatDateTime } from "functions/Helper";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const sortOption = [
  "Code ASC",
  "Code DESC",
  "Publish Time ASC",
  "Publish Time DESC",
  "Deactivated Date ASC",
  "Deactivated Date DESC"
];

const useStyles = makeStyles(styles);

export default function DeactivatedList() {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = React.useState({
    searchString: null,
    publicationStatus: 2,
    sort: 5
  });
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("/FeePolicyGroups", {
        signal: source.current.signal,
        params: {
          filter: filter,
          pagination: pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(record => {
            return {
              publicationStatusDescription: PublicationStatus(
                record.publicationStatus
              ),
              ...record,
              actions: (
                <div className="actions-right">
                  <Link to={"/admin/FeePolicyGroup/Detail/" + record.id}>
                    <Button color="info" className="like">
                      <VisibilityIcon /> VIEW
                    </Button>
                  </Link>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination, filter]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleSortOptionsChanged = e => {
    setFilter({ ...filter, sort: e.target.value });
  };

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              FEE POLICY GROUP - DEACTIVATED
            </h4>
          </CardHeader>
          <CardBody>
            <GridItem xs={12} md={12}>
              <FormControl fullWidth className={classes.selectFormControl}>
                <InputLabel
                  htmlFor="selSortOptions"
                  className={classes.selectLabel}
                >
                  SORT BY
                </InputLabel>
                <Select
                  inputProps={{
                    id: "selSortOptions",
                    name: "selSortOptions"
                  }}
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.seelct
                  }}
                  value={filter.sort ?? ""}
                  onChange={handleSortOptionsChanged}
                >
                  {sortOption.map((record, key) => (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value={key}
                      key={record}
                    >
                      <p>{record}</p>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  Header: "Code",
                  accessor: "code"
                },
                {
                  Header: "Name",
                  accessor: "name"
                },
                {
                  id: "commonFeePolicy",
                  Header: "Common Fee Policy",
                  accessor: d => d.commonFeePolicy.code
                },
                {
                  id: "peakHourFeePolicy",
                  Header: "Peak Hour Fee Policy",
                  accessor: d => d.peakHourFeePolicy.code
                },
                {
                  id: "deactivateTime",
                  Header: "Deactivate Time",
                  accessor: d =>
                    formatDateTime(new Date(d.deactivateTime + "Z"))
                },
                {
                  Header: "Deactivated By",
                  accessor: "deactivatedBy"
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
